import { deleteMembership } from '@/store/module/membership/action/delete.js';
import { getMemberships } from '@/store/module/membership/action/getMemberships.js';

export const actions = {
	delete: deleteMembership,
	getMemberships
};
